

function Support() {
  return (
    <>
      <div className="content-wrapper">
        <div
          className="content-heading d-flex
                          justify-content-between"
        >
          <div>Support</div>
          <div>
           
          </div>
        </div>
      </div>
    </>
  );
}

export default Support;
